import { deepEqual } from 'fast-equals';
import React from 'react';

export type Tab = unknown;
export interface TabContext {
  selectedTab: Tab;
  comparator: (a: Tab, b: Tab) => boolean;
  isSelected: (tabToTest: Tab) => boolean;
  setTab: (tab: Tab) => void;
}
const Context = React.createContext<TabContext>({
  selectedTab: 0,
  comparator: deepEqual,
  isSelected: () => true,
  setTab: () => undefined
});

export default Context;
